import Email from './Email';
import NIF from './NIF'

const EmailOrNIF = (value) =>
{
    if (value.includes('@')) {
        return Email(value)
    } else {
        return NIF(value)
    }
}

export default EmailOrNIF;